import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import utils from '@/jslibs/utils' // getToken from cookie


NProgress.configure({
	showSpinner: false
}) // NProgress Configuration



const Login = () => import('@/vuepage/Login');
const Index = () => import('@/vuepage/Index');
const Course = () => import('@/vuepage/components/Course');
const CourseDetail = () => import('@/vuepage/components/CourseDetail');
const CourseBuy = () => import('@/vuepage/components/CourseBuy');
const Training = () => import('@/vuepage/components/Training');
const TrainingDeatil = () => import('@/vuepage/components/TrainingDetail');
const TrainingConfirm = () => import('@/vuepage/components/TrainingConfirm');
const About = () => import('@/vuepage/components/About');
const Telenology = () => import('@/vuepage/components/Telenology');
const TelenologyDetail = () => import('@/vuepage/components/TelenologyDetail');
const Mine = () => import('@/vuepage/components/Mine');
const Invite = () => import('@/vuepage/components/Invite');
const BuyVip = () => import('@/vuepage/components/BuyVip');
const MyTraining = () => import('@/vuepage/components/MyTraining');
const MyTrainingDetail = () => import('@/vuepage/components/MyTrainingDetail');
const MyCart = () => import('@/vuepage/components/MyCart');
const CartCourseBuy = () => import('@/vuepage/components/CartCourseBuy');
const Message = () => import('@/vuepage/components/Message');
const MessageDetail = () => import('@/vuepage/components/MessageDetail');
const Question = () => import('@/vuepage/components/Question');
const AllCourse = () => import('@/vuepage/components/AllCourse');
const MyCourseDetail = () => import('@/vuepage/components/MyCourseDetail');
const StudyVideo = () => import('@/vuepage/components/studyVideo');
const Content = () => import('@/vuepage/components/content');

Vue.use(Router);

const whiteList = ['/login', '/index', '/course', '/courseDetail', '/courseBuy', '/training', '/trainingDetail',
	'/trainingConfirm', '/about', '/telenology', '/telenologyDetail', '/mine', '/invite', '/buyVip', '/myTraining',
	'/myTrainingDetail', '/myCart', '/cartCourseBuy', '/message', '/messageDetail', '/question', '/allCourse',
	'/myCourseDetail','/studyVideo','/content'
] // no redirect whitelist

var children = [];

const router = new Router({
	scrollBehavior(to, from, savedPosition) {
		// 滚动条滚动到哪个的位置
		return {
			x: 0,
			y: 0
		}
	},
	routes: [{
		path: '',
		redirect: '/login'
	}, {
		path: '/login',
		component: Login
	}, {
		path: '/index',
		component: Index,
	}, {
		path: '/course',
		component: Course,
	}, {
		path: '/courseDetail',
		component: CourseDetail,
	}, {
		path: '/courseBuy',
		component: CourseBuy,
	}, {
		path: '/training',
		component: Training,
	}, {
		path: '/trainingDetail',
		component: TrainingDeatil,
	}, {
		path: '/trainingConfirm',
		component: TrainingConfirm,
	}, {
		path: '/about',
		component: About,
	}, {
		path: '/telenology',
		component: Telenology,
	}, {
		path: '/telenologyDetail',
		component: TelenologyDetail,
	}, {
		path: '/mine',
		component: Mine,
	}, {
		path: '/invite',
		component: Invite,
	}, {
		path: '/buyVip',
		component: BuyVip,
	}, {
		path: '/myTraining',
		component: MyTraining,
	}, {
		path: '/myTrainingDetail',
		component: MyTrainingDetail,
	}, {
		path: '/myCart',
		component: MyCart,
	}, {
		path: '/cartCourseBuy',
		component: CartCourseBuy,
	}, {
		path: '/message',
		component: Message,
	}, , {
		path: '/messageDetail',
		component: MessageDetail,
	}, {
		path: '/question',
		component: Question,
	}, {
		path: '/allCourse',
		component: AllCourse,
	}, {
		path: '/myCourseDetail',
		component: MyCourseDetail,
	}, {
		path: '/studyVideo',
		component: StudyVideo,
	}, {
		path: '/content',
		component: Content,
	}],
	mode: 'history',
});


router.beforeEach((to, from, next) => {
	children = [];
	NProgress.start()
	console.log(utils.getCookie('authorization'), 999888)
	if (utils.getCookie("authorization")) {
		// 已登录且要跳转的页面是登录页
		if (to.path === '/login'||to.path === '/content') {
			//console.log("login")
			next()
			NProgress.done()
		} else {
			console.log(utils.getCookie('authorization'))
			if (utils.getCookie('authorization') == null) {
				console.log("ddd")
				next({
					path: '/login'
				})
				NProgress.done()
				// if (store.getters.roles.length === 0) { // 判断当前用户是否已拉取完user_info信息
				//   store.dispatch('GetInfo').then(() => { // 拉取user_info
				//     // 动态路由，拉取菜单
				//     loadMenus(next, to)
				//   }).catch(() => {
				//     store.dispatch('LogOut').then(() => {
				//       location.reload() // 为了重新实例化vue-router对象 避免bug
				//     })
				//   })
				// // 登录时未拉取 菜单，在此处拉取
				// } else if (store.getters.loadMenus) {
				//   // 修改成false，防止死循环
				//   store.dispatch('updateLoadMenus')
				//   loadMenus(next, to)
			} else {
				next()
			}
		}
	} else {
		console.log(whiteList.indexOf(to.path),9123)
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
			NProgress.done()
		}
	}

})

export const filterAsyncRouter = (routers, isRewrite = false) => { // 遍历后台传来的路由字符串，转换为组件对象
	return routers.filter(router => {
		if (isRewrite && router.children) {
			router.children = filterChildren(router.children)
		}
		if (router.component) {
			if (router.component === 'Layout') { // Layout组件特殊处理
				router.component = Layout
			} else if (router.component === 'ParentView') {
				router.component = ParentView
			} else {
				const component = router.component
				router.component = loadView(component)
			}
		}
		if (router.children && router.children.length) {
			router.children = filterAsyncRouter(router.children, router, isRewrite)
		}
		return true
	})
}

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

export default router;